import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import TabNavigation from "../../components/layout/TabNavigation";
import { questionnaireTabs } from "../../config/tabs";

const QuestionnairesOverview = lazy(() => import("./tabs/QuestionnairesOverview"));
const AllQuestionnairesTab = lazy(() => import("./tabs/AllQuestionnairesTab"));
const InstancesTab = lazy(() => import("./tabs/InstancesTab"));
const SettingsTab = lazy(() => import("./tabs/SettingsTab"));

const Questionnaires = () => {
  return (
    <div className="qnaires-page h-full min-h-0 flex flex-col p-4 sm:p-6">
      <div className="shrink-0">
        <TabNavigation tabs={questionnaireTabs} />
      </div>

      {/* clave: min-h-0 en el contenedor que será el padre del área scrollable */}
      <div className="qnaires-content flex-1 min-h-0 overflow-hidden">
        <Suspense fallback={<div className="loading-spinner p-4">Cargando...</div>}>
          {/* clave: el contenedor interno ocupa toda la altura para que scrollHeight='flex' funcione */}
          <div className="h-full min-h-0 flex flex-col">
            <Routes>
              <Route index element={<QuestionnairesOverview />} />
              <Route path="all" element={<AllQuestionnairesTab questionnaires={[]} />} />
              <Route
                path="responses"
                element={<InstancesTab questionnaires={[]} instancesByQ={{}} questionsByQ={{}} />}
              />
              <Route
                path="settings"
                element={<SettingsTab users={[]} value={{ useDefaultAdmin: true, adminUserId: undefined }} onSave={() => {}} />}
              />
            </Routes>
          </div>
        </Suspense>
      </div>
    </div>
  );
};

export default Questionnaires;
